<nav *ngIf="shouldShowBanner" class="navbar navbar-default">
    <div class="container-fluid">
        <div class="row">
            <div class="text-center">
                <span class="banner-text"> 🎉&nbsp;Exclusive offer ends in</span>
                <span class="banner-text">&nbsp;{{hours}}h</span>
                <span class="banner-text">&nbsp;{{minutes}}m</span>
                <span class="banner-text">&nbsp;{{seconds}}s</span>

                <span *ngIf="!isMobile || !smallScreen">&nbsp; | &nbsp;</span>
                <br *ngIf="isMobile || smallScreen">

                <span class="banner-text">{{ bannerMessage }}</span>
            </div>
        </div>
    </div>
</nav>

